var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTailwindLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1279_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 0C13.9334 0 10.7666 3.32474 9.5 9.97403C11.4 6.64929 13.6166 5.40253 16.15 6.23377C17.5953 6.70792 18.6285 8.08422 19.772 9.6074C21.6349 12.089 23.7908 14.961 28.5 14.961C33.5666 14.961 36.7334 11.6363 38 4.98701C36.1 8.31175 33.8834 9.55851 31.35 8.72727C29.9047 8.25312 28.8715 6.87682 27.728 5.35364C25.8651 2.87201 23.7092 0 19 0ZM9.5 14.961C4.43338 14.961 1.26662 18.2858 0 24.9351C1.9 21.6103 4.11662 20.3636 6.65 21.1948C8.09534 21.669 9.12846 23.0453 10.272 24.5684C12.1349 27.0501 14.2908 29.9221 19 29.9221C24.0666 29.9221 27.2334 26.5973 28.5 19.9481C26.6 23.2728 24.3834 24.5195 21.85 23.6883C20.4047 23.2142 19.3715 21.8379 18.228 20.3147C16.3651 17.8331 14.2092 14.961 9.5 14.961Z",
    fill: "url(#paint0_linear_1279_366)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1279_366",
    x1: -105.564,
    y1: 957.506,
    x2: 3559.9,
    y2: 2567.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2298BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED7B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindLogo);
export default __webpack_public_path__ + "static/media/tailwindLogo.11b0d5c6689c682da1075eb83657b815.svg";
export { ForwardRef as ReactComponent };